import { useMemo } from "react";
import clsx from "clsx";
import type { GdPlaceholderCategory } from "@/lib/gdPlaceholders";

export function GdPlaceholderPicker({
  categories,
  activeCategory,
  onCategoryChange,
  editable = true,
  onInsert,
}: {
  categories: GdPlaceholderCategory[];
  activeCategory: string;
  onCategoryChange: (key: string) => void;
  editable?: boolean;
  onInsert: (token: string) => void;
}) {
  const activeItems = useMemo(() => {
    return categories.find((c) => c.key === activeCategory)?.items || [];
  }, [activeCategory, categories]);

  return (
    <div className="grid min-h-0 flex-1 grid-cols-[8.5rem_minmax(0,1fr)]">
      <aside className="overflow-y-auto border-r border-separator bg-card-elevated/40 py-1">
        {categories.map((cat) => (
          <button
            key={cat.key}
            type="button"
            className={clsx(
              "block w-full px-2.5 py-2 text-left text-[11px] font-semibold uppercase tracking-wide transition",
              activeCategory === cat.key
                ? "border-l-2 border-label bg-card text-label"
                : "border-l-2 border-transparent text-label-secondary hover:bg-card hover:text-label",
            )}
            onClick={() => onCategoryChange(cat.key)}
          >
            {cat.label}
          </button>
        ))}
      </aside>
      <div className="overflow-y-auto p-3">
        <div className="space-y-2">
          {activeItems.map((item) => (
            <button
              key={item.token}
              type="button"
              disabled={!editable}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => onInsert(item.token)}
              className="block w-full rounded-lg border border-transparent px-2 py-1.5 text-left transition hover:border-separator hover:bg-card"
              title="An Cursorposition einfügen"
            >
              <p className="text-sm text-label">{item.label}</p>
              <span className="mt-1 inline-block rounded-md bg-separator/60 px-2 py-0.5 font-mono text-[11px] text-label-secondary">
                {item.token}
              </span>
            </button>
          ))}
          {!activeItems.length ? (
            <p className="text-sm text-label-secondary">Keine Platzhalter in dieser Kategorie.</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
